import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import useProtecaoDeRota from '../hooks/useProtecaoDeRota';
import { Spin, message } from 'antd';
import TabelaDados from '../componentes/Table';
import useApi from '../hooks/useApi';
import ModalDelete from '../componentes/modal/DeleteGrupo';
import ModalAdd from '../componentes/modal/AddGrupo';
import ModalEdit from '../componentes/modal/EditarGrupo';

const PaginaGrupo = () => {
  const verificando = useProtecaoDeRota();
  const [grupos, setGrupos] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const previousGruposRef = useRef([]);  // Ref para armazenar dados anteriores

  const { callApi } = useApi('https://vision.alfama.com/api/view/grupos_permissao', { 
    includeToken: true,
  });

  const extraColumns = useMemo(() => [
    { id: 'codigo_grupo', name: 'CODIGO RLS', sort: true, mwidth: '5%' },
    { id: 'nome', name: 'Nome', sort: true, width: '10%' },
    { id: 'descricao', name: 'Descrição', sort: true, width: '5%' },
    { id: 'data_atualizacao', name: 'Atualizado em', sort: false, width: '5%' },
    
  ], []);

  const showMessage = useCallback((type, content) => {
    message[type](content);
  }, []);

  const formatarGrupos = useCallback((grupos) => {
    return grupos.map(grupo => ({
      id: grupo.grupo_id,
      nome: grupo.nome_grupo,
      descricao: grupo.descricao_grupo,
      codigo_grupo: grupo.codigo_grupo,
      data_criacao: grupo.grupo_data_criacao,
      data_atualizacao: grupo.grupo_data_atualizacao,
      status: grupo.situacao_grupo,
    }));
  }, []);
  
  const buscarGrupos = useCallback(async () => {
    try {
      const resultado = await callApi();
      const gruposFormatados = formatarGrupos(resultado);

      if (JSON.stringify(gruposFormatados) !== JSON.stringify(previousGruposRef.current)) {
        setGrupos(gruposFormatados);
        previousGruposRef.current = gruposFormatados;
      }
    } catch (erro) {
      console.error('Erro ao buscar grupos:', erro);
      showMessage('error', 'Não foi possível carregar os grupos');
    } finally {
      setIsLoading(false);
    }
  }, [callApi, formatarGrupos, showMessage]);

  const handleModalOpen = useCallback((type, id) => {
    setModalType(type);
    setSelectedId(id);
    setModalVisible(true);
  }, []);

  const handleModalClose = useCallback(() => {
    setModalVisible(false);
    setModalType(null);
    setSelectedId(null);
    buscarGrupos();
  }, [buscarGrupos]);

  const handleDeleteConfirm = useCallback(async (success) => {
    if (success) {
      await buscarGrupos();
    }
    handleModalClose();
  }, [buscarGrupos, handleModalClose]);

  const handleEditConfirm = useCallback(async (success) => {
    if (success) {
      await buscarGrupos();
    }
    handleModalClose();
  }, [buscarGrupos, handleModalClose]);

  const handleAddConfirm = useCallback(async (success) => {
    if (success) {
      await buscarGrupos();
    }
    handleModalClose();
  }, [buscarGrupos, handleModalClose]);

  const getSelectedGrupo = useCallback((id) => {
    return grupos.find(grupo => grupo.id === id) || {};
  }, [grupos]);

  useEffect(() => {
    if (!verificando) {
      buscarGrupos();
    }

    const intervalId = setInterval(() => {
      buscarGrupos();
    }, 300000);

    return () => {
      clearInterval(intervalId);
    };
  }, [buscarGrupos, verificando]);



  return (
    <>
      <TabelaDados 
        data={grupos} 
        extraColumns={extraColumns}
        onModalOpen={handleModalOpen}
        link_visualizar="grupo"
      />

      {modalType === 'delete' && (
        <ModalDelete
          visible={modalVisible}
          id={selectedId}
          onCancel={handleModalClose}
          onConfirm={handleDeleteConfirm}
        />
      )}

      {modalType === 'edit' && (
        <ModalEdit
          visible={modalVisible}
          id={selectedId}
          initialData={getSelectedGrupo(selectedId)}
          onCancel={handleModalClose}
          onConfirm={handleEditConfirm}
        />
      )}

      {modalType === 'add' && (
        <ModalAdd
          visible={modalVisible}
          onCancel={handleModalClose}
          onConfirm={handleAddConfirm}
        />
      )}
    </>
  );
};

export default PaginaGrupo;